module.exports = __webpack_public_path__ + "static/media/list-1.6179b2ea.svg";